import { 
    getMeterRecord
} from "@/apis/company/meterRecord.js"; 

/* 
  這邊可以改為用 types 物件取代 matutions_type.js (繼續用也可以)
  然後在前面加上模組名稱作為前綴，用來避免與其他模組重複。
  因為 action、mutation、和 getter 依然是註冊在全域的命名空間
*/
const types = {
    set_meter_record_obj: 'bizMeterRecode/set_meter_record_obj',
    set_mode: 'bizMeterRecode/set_mode',
    set_filter_query: 'bizMeterRecode/set_filter_query',
    set_filter_default: 'bizMeterRecode/set_filter_default',
}

// count state 必須是 Object
const state = {
    meterRecordObj: {},
    filterQuery: {
        date: [],
    },
    mode: null,
    isDefault: true,
}

// getters 也可以整理到這邊直接返回 count 內容
const getters = {
    GET_BIZ_METER_RECORD_MGT_OBJ: (state) => {
        return state.meterRecordObj
    },
    GET_BIZ_METER_RECORD_MGT_MODE: (state) => {
        return state.mode
    },
    GET_BIZ_METER_RECORD_MGT_FILTER_QUERY: (state) => {
        return state.filterQuery
    },
    GET_BIZ_METER_RECORD_MGT_FILTER_DEFAULT: (state) => {
        return state.isDefault
    },
}

// actions 也是以 Object 形式建構。
const actions = {
    getBizMeterRecodeMgtList ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            getMeterRecord(data)
            .then(res => {
                // console.log(res)
                if( res.data.status == "SUCCESS" ){
                    console.log(res)
                    commit(types.set_meter_record_obj, res.data.result);
                    resolve()
                }
            })
            .catch(err => {
                reject(err)
            })
            
        })
    },
    setBizMeterRecodeFilterQuery ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            commit(types.set_filter_query, value);
            resolve()
        })
    },
    setBizMeterRecodeFilterDefault ( {commit} ) {
        return new Promise((resolve, reject) => {
            let filter = {
                date: [],
            }
            commit(types.set_filter_default, filter);
            resolve()
        })
    },
}

// mutations
const mutations = {
    [types.set_meter_record_obj](state, data){
        state.meterRecordObj = data
    },
    [types.set_mode](state, data){
        state.mode = data
    },
    [types.set_filter_word](state, data){
        state.filterWord = data
        state.isDefault = false
    },
    [types.set_filter_query](state, data){
        state.filterQuery = data
        state.isDefault = false
    },
    [types.set_filter_result_total](state, data){
        state.filterResultTotal = data
    },
    [types.set_filter_default](state, data){
        state.filterQuery = data
        setTimeout(()=>{
            state.isDefault = true
        },100)
    },
}

/*
因為我們把 vuex 所有職權都寫在同一隻檔案，
所以必須要 export 出去給最外層 index.js 組合使用
*/
export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/bussiness/mgtCategory/leaseMgt/meterRecord.js